import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import { observer, inject } from 'mobx-react'
import { WingBlank } from 'antd-mobile'
import tabBar from '@componentsG/tabBar'
import * as styles from './style/index.scss'
import LangSwitch from '@componentsG/switchLang'
import SwitchRegion from '@componentsG/switchRegion'
import CarouselG from '@componentsG/carousel'
import PackageItemG from '@componentsG/packageItem'
import DotTitle from '@componentsG/dotTitle'
import { deepClone, getUrlSearch } from '@src/utils';
import { FormattedMessage } from 'react-intl'
import FlowUse from './cmp/flowUse'
import Active from './cmp/active'
import ActiveSuccess from './cmp/active/success'
import ActiveModal from './cmp/active/modal'
import homeSuggest from '@assets/img/suggest/home-suggest.png'
import ScanImg from '@assets/img/global/scan.png'
import intl from '@utils/intl';
import { getLang } from '@src/utils'
import { Toast } from 'antd-mobile'
import SockJsClient from 'react-stomp'
import { OPERATOR_V, TRYBUY_EVENT_TRACING_PAGE } from '@src/constants';
@inject('userStore', 'homeStore', 'homeStoreG')
@observer
class HomeG extends ComponentExt<any> {
    private homeStore: any
    private userStore: any
    private homeStoreG: any
    private readonly userInfo: any = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    private countryCode: string
    private countryName: string
    private clientRef: any;

    constructor(props) {
        super(props)
        this.homeStore = props.homeStore
        this.userStore = props.userStore
        this.homeStoreG = props.homeStoreG
    }
    async componentDidMount() {
        this.showLoading()
        this.homeStoreG.vf_iframeSuccess(null)
        this.userStore.sendEventTracing({
            pageCode: TRYBUY_EVENT_TRACING_PAGE.TRYBUY_PAGE_HOME,
            buttonCode: '',
            buttonInfo: ''
        })
        try {
            // 当月加油包记录
            this.homeStore.getRefuelPackageOrderRecord(this.userInfo.iccid)
            await this.homeStore.getBannerConfig(this.userInfo.iccid)
            await this.homeStoreG.getSimInfo(this.userInfo.iccid)
            if (this.homeStoreG.simInfo.active === false) {
                // 查询激活的套餐
                await this.userStore.getInitPackage(this.homeStoreG.simInfo.initproduct, this.userInfo.iccid)
            }
            // 获取地区
            await this.homeStoreG.getSubAreas(this.userInfo.iccid)
            const subAreas = deepClone(this.homeStoreG.subAreas)
            if (localStorage.getItem('chl') === 'tabletApp') {
                await this.homeStoreG.getPadControlFlag()
            }
            // 下单填写billing address时用到
            this.setCountryInfo({
                countryCode: subAreas.length > 0 ? subAreas[0].childAreaCode : '',
                countryName: subAreas.length > 0 ? subAreas[0].childAreaName : ''
            })

            await this.homeStore.getAllAvailProductList({
                simId: this.userInfo.iccid,
                areaId: subAreas.length > 0 ? subAreas[0].parentAreaId : '',
                cargoType: subAreas.length > 0 ? subAreas[0].cargoType : '',
                areaCode: subAreas.length > 0 ? subAreas[0].childAreaCode : ''
            })
            await this.homeStore.getRefuelPackage({
                simId: this.userInfo.iccid,
                cargoType: subAreas.length > 0 ? subAreas[0].cargoType : '',
                areaCode: subAreas.length > 0 ? subAreas[0].childAreaCode : ''
            })
        } catch (e) {
        } finally {
            this.hideLoading()
        }
    }

    // 切换地区
    changeRegion = async (option) => {
        this.setCountryInfo({
            countryCode: option.countryCode,
            countryName: option.countryName
        })
        this.homeStoreG.setCurrentArea(option.areaId)
        this.homeStoreG.setCurrentCargoType(option.cargoType)
        await this.homeStore.getAllAvailProductList({
            simId: this.userInfo.iccid,
            areaId: option.areaId,
            cargoType: option.cargoType,
            areaCode: option.countryCode
        })
        if (this.homeStoreG.simInfo.startDate) {
            await this.homeStore.getRefuelPackage({
                simId: this.userInfo.iccid,
                cargoType: option.cargoType,
                areaCode: option.countryCode
            })
        }
    }

    handleActive = async () => {
        if (this.homeStoreG.simInfo.operatorsId == 20) {
            await this.homeStoreG.activePackageVF(this.userInfo.iccid)
        } else {
            await this.homeStoreG.activePackage(this.userInfo.iccid)
        }
    }

    setCountryInfo = ({ countryCode, countryName }) => {
        this.countryCode = countryCode
        this.countryName = countryName
    }

    goToPackageDetail = ({ goodsReleaseId, goodsType, cargoType, activityPlan }) => {
        const activityId = activityPlan.length > 0 ? activityPlan[0].activityId : ''
        this.goToPath(`/global/packageDetail/${this.countryCode}/${this.countryName}/${goodsReleaseId}/${goodsType}/${cargoType}/${activityId}`)
    }

    getMessage = async (res) => {
        if (res.data.success) {
            Toast.success(res.data.msg, 3, null, true)
        } else {
            Toast.fail(res.data.msg, 3, null, true)
        }
        setTimeout(() => {
            window.location.reload();
        }, 3000);
    };

    render() {
        const packageList = deepClone(this.homeStore.productList) || []
        const refuelPackageList = deepClone(this.homeStore.refuelPackageList) || []
        const refuelPackageOrderRecord = deepClone(this.homeStore.refuelPackageOrderRecord) || {}
        const simInfo = deepClone(this.homeStoreG.simInfo)
        const initPackage = deepClone(this.userStore.initPackage)
        return (
            <>
                {this.homeStoreG.vf_iframe && (
                    <div style={{ height: '100vh', width: "100%" }}>
                        <iframe
                            id="myFrame"
                            width="100%"
                            height="100%"
                            frameBorder={0}
                            scrolling="no"
                            src={this.homeStoreG.vf_iframe}
                            // src={'https://netmon-api-uat.netmon2.technacy.it/api/lenovoconnectuat/v3/registration/b2c/registered'}
                        />
                        <SockJsClient
                            url={process.env.APP_ENV === 'dev' ? 'http://aoacuatwap.lenovoconnect.com/stomp' : '/stomp'}
                            topics={[`/user/${this.userInfo.iccid}/topic/syncMessage`]}
                            onMessage={this.getMessage}
                            options={{ socketId: this.userInfo.iccid }}
                            headers={{ socketId: this.userInfo.iccid }}
                            autoReconnect={false}
                            onDisconnect={() => {
                                console.log('disconnect')
                            }}
                            ref={(client) => {
                                this.clientRef = client
                            }}
                        />
                    </div>
                )}
                {!this.homeStoreG.vf_iframe && (
                    <>
                        <header className={styles.header}>
                            {localStorage.getItem('chl') !== 'tabletApp' && <div className={styles.scan} onClick={() => this.goToPath('/global/bind-simCard')}>
                                <img src={ScanImg} />
                                <div className={styles.text}>
                                    <p>{intl.formatMessage({ id: 'home.header.upload' })}</p>
                                    <span>{intl.formatMessage({ id: 'home.header.iccid' })}</span>
                                </div>
                            </div>}
                            <LangSwitch />
                        </header>
                        <CarouselG list={deepClone(this.homeStore.bannerConfig) || []} operatorsId={simInfo.operatorsId} active={simInfo.active} />
                        <WingBlank>
                            {/*激活弹框提示*/}
                            {
                                simInfo.active === false &&
                                <ActiveModal dto={initPackage} operatorsId={simInfo.operatorsId} handleActive={this.handleActive} />
                            }
                            {/*激活成功弹框*/}
                            {
                                this.homeStoreG.activeSuccess &&
                                <ActiveSuccess handleClose={() => this.homeStoreG.setActiveSuccess(false)} />
                            }
                            {/*流量使用情况及当前套餐*/}
                            {
                                simInfo.startDate &&
                                <FlowUse simInfo={simInfo} refuelPackageOrderRecord={refuelPackageOrderRecord} refuelPackageEndDate={this.homeStore.refuelPackageEndDate} />
                            }
                            {/*激活套餐*/}
                            {
                                simInfo.active === false &&
                                <Active
                                    dto={initPackage}
                                    operatorsId={simInfo.operatorsId}
                                    handleActive={this.handleActive}
                                />
                            }
                            <>
                                <div className={styles.areaIntroTitleWrap}>
                                    <p><FormattedMessage id={simInfo.operatorsId === OPERATOR_V.HUE ? "home.area.intro.titleHue" : "home.area.intro.title"} /></p>
                                    <SwitchRegion
                                        subAreas={deepClone(this.homeStoreG.subAreas)}
                                        changeRegion={this.changeRegion}
                                    />
                                </div>
                                {/*套餐可用地区说明*/}
                                <p className={styles.areaInfo}>
                                    {simInfo.operatorsId == 20 ? getLang() === 'it' ? <>
                                        I nostri piani possono coprire tutti i paesi <strong>dell'UE</strong> (Austria, Belgio, Bulgaria, Croazia, Cipro, Repubblica Ceca, Danimarca, Estonia, Finlandia, Francia, Germania, Grecia, Ungheria, Irlanda, Italia, Lettonia, Lituania, Lussemburgo, Malta, Paesi Bassi, Polonia , Portogallo, Romania, Slovacchia, Slovenia, Spagna e Svezia), <strong>e Islanda, Norvegia, Regno Unito</strong>.
                                    </> : <>
                                        Our plans can cover all <strong>EU countries</strong> (Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Gibraltar, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden),<strong> plus Iceland, Norway, United Kingdom</strong>.
                                    </> :
                                        <FormattedMessage
                                            id={simInfo.operatorsId === OPERATOR_V.HUE ? 'home.area.intro.contentHUE' : 'home.area.intro.content'}
                                            values={{
                                                cta: chunks => <strong>{chunks}</strong>
                                            }}
                                        />}
                                </p>
                                <p className={styles.vatIntro}>
                                    <FormattedMessage id="home.area.intro.vatIntro" />
                                </p>
                            </>
                            {/*基础套餐*/}
                            {
                                packageList.length > 0 && simInfo.active === true &&
                                <>
                                    <DotTitle messageId={simInfo.operatorsId === OPERATOR_V.HUE ? "package.extend.titleHue" : "package.extend.title"} />
                                    {
                                        packageList.map(item => (
                                            <PackageItemG
                                                type="0"
                                                dto={item}
                                                key={item.goodsReleaseId}
                                                goToPackageDetail={this.goToPackageDetail}
                                            />
                                        ))
                                    }
                                </>
                            }
                            {/*加油包*/}
                            {
                                refuelPackageList.length > 0 &&
                                <>
                                    <DotTitle messageId={simInfo.operatorsId === OPERATOR_V.HUE ? "package.expand.titleHue" : "package.expand.title"} />
                                    {
                                        refuelPackageList.map(item => (
                                            <PackageItemG
                                                type="1"
                                                dto={item}
                                                key={item.goodsReleaseId}
                                                goToPackageDetail={this.goToPackageDetail}
                                            />
                                        ))
                                    }
                                </>
                            }
                        </WingBlank>
                        {/* 建议入口 */}
                        {localStorage.getItem('chl') === 'tabletApp' && this.homeStoreG.padControlFlag === 'true' &&
                            <div className={styles.suggest} onClick={() => this.goToPath('/global/suggest')}>
                                <img src={homeSuggest} alt="" />
                                <span><FormattedMessage id="home.area.intro.suggest" /></span>
                            </div>}
                    </>
                )}

            </>
        )
    }
}

export default tabBar(HomeG)
